// src/data/topics.js
// ─── IDは自動採番のため手動管理不要 ─────────────────────────────────
// ─── 日付の新しい順に並べるだけでOK ─────────────────────────────────

const topicsRaw = [
        {
    title: "資料・情報ページの設置",
    date: "2026-08-26",
    thumbnail: "/images/ev_o.jpg",
    summary: "資料・情報ページを設置しました",
    content: [
      { type: "text", data: "弊社が関わる分野の情報をご紹介するページを新たに新設しました。" },
      { type: "text", data: "メニューバーのResource・資料・情報ボタンよりご確認ください。" },
    ],
  },
      {
    title: "ポンプ技術セミナー",
    date: "2026-06-29",
    thumbnail: "/images/ev_b.jpg",
    summary: "ポンプ技術セミナーを実施しました",
    content: [
      { type: "text", data: "弊社3Fスペースにてポンプメーカー様によるポンプ技術セミナーを実施しました。" },
      { type: "text", data: "ポンプの構造・作動原理から選定の悩みまで、短時間ではありますがご説明頂きました。" },
      { type: "text", data: "実際の設置事例をもとにポンプの構造・作動原理をわかりやすく解説。最新製品の特徴紹介などに加え、" },
      { type: "text", data: "選定時によくある問題点や現状の悩みなどについて具体的な改善策を交えながら質疑応答を行いました。" },
    ],
  },
     {
    title: "社員旅行のご報告",
    date: "2026-06-5",
    thumbnail: "/images/ev_20260605_1.jpg",
    summary: "6月5日～6月6日にかけ、社員旅行に行ってまいりました。",
    content: [
      { type: "text", data: "毎年、旅行委員がアイデアを出し合い、こだわり抜いた一泊二日の社員旅行を企画・実行しています。" },
      { type: "text", data: "そして今年は、2年に1度のお楽しみ『エクシブ利用年』！今回の目的地は自然豊かな長野県にあるエクシブ蓼科です。" },
      { type: "image", data: "/images/ev_20260605_1.jpg" },
      { type: "text", data: "当日はバス2台に分かれて出発！ホテルまでは約3時間の道のりです。" },
      { type: "text", data: "道中では山梨県甲府市で昼食を楽しみ、市内観光も満喫しました。" },
      { type: "image", data: "/images/ev_20260605_2.jpg" },
      { type: "text", data: "景色や会話を楽しんでいるうちに、気づけばホテルへ到着！" },
      { type: "text", data: "宴会までは少し時間があったため、温泉でゆったり疲れを癒したり、シミュレーションゴルフを楽しんだりと、思い思いの時間を過ごしました。" },
      { type: "image", data: "/images/ev_20260605_3.jpg" },
      { type: "text", data: "夜の宴会では、テーブル対抗の秒数当てゲームや格付けチェックさながらのテイスティング企画で大盛り上がり！" },
      { type: "text", data: "二次会ではラウンジ、カラオケ、ビリヤードなどホテル内の施設を満喫し、楽しい夜を過ごしました。" },
      { type: "text", data: "翌朝は優雅な朝食からスタート。ラウンジでモーニングコーヒーを楽しみながら、ゆったりとした時間を満喫しました。" },
      { type: "image", data: "/images/ev_20260605_4.jpg" },
      { type: "image", data: "/images/ev_20260605_5.jpg" },
      { type: "text", data: "名残惜しくホテルを後にし、続いて向かったのは甲府にある桔梗信玄餅工場です。" },
      { type: "text", data: "事前予約していた大人気の『桔梗信玄餅詰め放題』に挑戦し、お土産選びも楽しみました。" },
      { type: "text", data: "昼食を済ませた後は、思い出をたくさん抱えて帰路につきました。" },
      { type: "image", data: "/images/ev_20260605_6.jpg" },
      { type: "text", data: "1日目のバス車内は笑い声が絶えないほど賑やかでしたが、2日目は旅行を満喫した反動か、ぐっすり眠る方が続出していました。" },
      { type: "text", data: "今年もたくさんの思い出ができた社員旅行となりました。来年も皆さんに楽しんでいただける企画を準備していきたいと思います！" },
    ],
  },
    {
    title: "超音波洗浄技術セミナー",
    date: "2026-05-13",
    thumbnail: "/images/ev_b.jpg",
    summary: "超音波洗浄技術セミナーを実施しました",
    content: [
      { type: "text", data: "弊社3Fスペースにて超音波メーカー様による超音波洗浄技術セミナーを実施しました。" },
      { type: "text", data: "超音波洗浄の基本メカニズム（キャビテーション効果など）から、" },
      { type: "text", data: "洗浄方法、機器の選定方法などを短時間ではありますがご説明頂きました。" },
    ],
  },
   {
    title: "創業六十周年のお知らせ",
    date: "2026-05-12",
    thumbnail: "/images/ev_o.jpg",
    summary: "2026年5月12日　創業六十周年を迎えました",
    content: [
      { type: "text", data: "2026年5月12日、株式会社ZENKYOは創業六十周年という節目を迎えました。" },
      { type: "text", data: "六十年にわたり受け継いできた想いと信頼。" },
      { type: "text", data: "その歴史に誇りを持ち、これからも新たな価値を創造してまいります。" },
      { type: "image", data: "/images/ev_20260512_1.jpg" },
    ],
  },
  {
    title: "東京ドームシーズンシート",
    date: "2026-04-10",
    thumbnail: "/images/ev_20260410_1.jpg",
    summary: "ZENKYOでは東京ドームシーズンシートを契約しています。",
    content: [
      { type: "text", data: "4年ぶりに東京ドームシーズンシートを福利厚生の一環として契約!" },
      { type: "text", data: "4月10日（金）の巨人VSヤクルト戦を観戦してまいりました!" },
      { type: "image", data: "/images/ev_20260410_2.jpg" },
      { type: "text", data: "今回契約した席はスターシートAとなり、選手が非常に間近に見えます!" },
      { type: "text", data: "当日はなんと生ビール半額ナイターの日、ラッキーでした・・・。" },
      { type: "text", data: "非日常の空間を味わえ大満足の1日でした。" },
      { type: "image", data: "/images/ev_20260410_3.jpg" },
    ],
  },
  {
    title: "認定のお知らせ",
    date: "2026-03-23",
    thumbnail: "/images/certification_20260323.jpg",
    summary: "全国健康保険協会健康優良企業に認定されました",
    content: [
      { type: "text", data: "弊社では「健康」を第一に考えた取り込みを推進しています。" },
      { type: "text", data: "その一環から全国健康保険協会埼玉支部が所管する健康経営優良企業の認定を受けました。" },
      { type: "text", data: "今後も従業員の健康に留意した経営活動を進めてまいります。" },
    ],
  },
    {
    title: "認定のお知らせ",
    date: "2026-03-09",
    thumbnail: "/images/health_2026.jpg",
    summary: "健康経営優良法人2026事業者に認定されました",
    content: [
      { type: "text", data: "弊社では「健康」を第一に考えた取り込みを推進しています。" },
      { type: "text", data: "その一環から経済産業省が所管する健康経営優良法人を申請。" },
      { type: "text", data: "この度健康経営優良法人2026事業者にて認定を受けました" },
      { type: "text", data: "今後も従業員の健康に留意した経営活動を進めてまいります。" },
    ],
  },
  {
    title: "ハラスメント講習会",
    date: "2026-01-23",
    thumbnail: "/images/ev_b.jpg",
    summary: "全社員対象ハラスメント講習会を実施しました",
    content: [
      { type: "text", data: "昨今ハラスメントというワードは皆さんご存知かと思います" },
      { type: "text", data: "弊社でも「ハラスメント、ダメ、絶対」をモットーに企業活動していますが" },
      { type: "text", data: "どこからハラスメントなの？指導との違いは？など疑問に思う方も・・・" },
      { type: "text", data: "そこで今回講師の方を招き１時間という短い時間でありますが講習を行って頂きました！" },
      { type: "text", data: "なるほど・・・と唸る方、これくらいで！？などビックリする方などなど・・・" },
      { type: "text", data: "自分の感覚と相手の感覚で違いがあるので、自分が加害者とならないよう気をつけてまいりましょう！" },
    ],
  },
  {
    title: "ビギナー向け半導体勉強会",
    date: "2026-01-07",
    thumbnail: "/images/ev_b.jpg",
    summary: "ビギナー向け半導体勉強会を実施しました",
    content: [
      { type: "text", data: "弊社は中途入社100%にて様々な業界出身の方がご入社されます" },
      { type: "text", data: "半導体とは・・・？という方も中にはいらっしゃるため、定期的に勉強会を開催しています" },
      { type: "text", data: "今回は講師になんと弊社代表の安藤が登壇、約２時間ご教授頂きました！" },
      { type: "text", data: "入社間もない方や若手を中心に参加し、皆さま真剣に聞いておられました" },
      { type: "text", data: "今回は基礎編で次回は初級編を講演予定とのことです" },
      { type: "text", data: "定期的に行われる勉強会に積極参加し知識を蓄えていきましょう！" },
    ],
  },
  {
    title: "2025年末年始休暇",
    date: "2025-12-26",
    thumbnail: "/images/ev_o.jpg",
    summary: "2025年末年始休暇のお知らせ",
    content: [
      { type: "text", data: "誠に勝手ながら、下記期間を年末年始休暇とさせていただきます" },
      { type: "text", data: "休暇期間：2025年12月27日（土）～2026年1月4日（日）" },
      { type: "text", data: "緊急のご要件は各担当まで直接ご連絡ください" },
    ],
  },
  {
    title: "2025年ZENKYO忘年会",
    date: "2025-12-19",
    thumbnail: "/images/ev_20251219_1.jpg",
    summary: "2025年年末恒例の忘年会を開催しました",
    content: [
      { type: "text", data: "早いもので2025年も12月に入り、毎年恒例の忘年会です" },
      { type: "text", data: "毎年お馴染みの木曽路戸田店さんにお世話になります！" },
      { type: "text", data: "木曽路さんのお料理、いつも美味しく頂いています" },
      { type: "image", data: "/images/ev_20251219_2.jpg" },
      { type: "image", data: "/images/ev_20251219_3.jpg" },
      { type: "image", data: "/images/ev_20251219_4.jpg" },
      { type: "image", data: "/images/ev_20251219_5.jpg" },
      { type: "image", data: "/images/ev_20251219_1.jpg" },
      { type: "text", data: "イベントではスピードビンゴによる景品争奪戦や恒例のギフト券じゃんけん大会など行いました" },
      { type: "text", data: "二次会は有志でカラオケへ・・・お疲れ様でした！" },
    ],
  },
    {
    title: "認定のお知らせ",
    date: "2025-12-19",
    thumbnail: "/images/certification_20251219.jpg",
    summary: "埼玉県受動喫煙防止対策実施説に認定されました。",
    content: [
      { type: "text", data: "弊社では「健康」を第一に考えた取り込みを推進しています。" },
      { type: "text", data: "その一環から敷地内については「完全禁煙」を徹底しております。" },
      { type: "text", data: "今回埼玉県より敷地内禁煙施設として認定を受けました" },
      { type: "text", data: "今後も従業員の健康に留意した経営活動を進めてまいります。" },
    ],
  },
  {
    title: "縦型石英管洗浄装置",
    date: "2025-11-19",
    thumbnail: "/images/ev_bsouti.jpg",
    summary: "「縦型石英管洗浄装置」の勉強会を実施しました",
    content: [
      { type: "text", data: "今回の装置は弊社１ＦにあるＣＲで説明を実施、業務で普段ＣＲに入らない方なども多数参加されました" },
      { type: "text", data: "皆さん真剣に装置概要や組付時に起こった出来事などの説明を聞き、質問などもしていました" },
    ],
  },
  {
    title: "社名変更",
    date: "2025-10-01",
    thumbnail: "/images/ev_o.jpg",
    summary: "「株式会社ＺＥＮＫＹＯ」へ社名を変更しました",
    content: [
      { type: "text", data: "弊社は60年の節目を迎え、全協化成工業株式会社から株式会社ＺＥＮＫＹＯへ社名を変更しました" },
    ],
  },
  {
    title: "総務・生産管理部合同懇親会",
    date: "2025-09-18",
    thumbnail: "/images/ev_20250918_3.jpg",
    summary: "2025年期末での合同懇親会を開催しました",
    content: [
      { type: "text", data: "2025年2回目の権利を利用して合同懇親会です" },
      { type: "text", data: "今回はオステリアオオサキ戸田店さんにお世話になります！" },
      { type: "text", data: "全14名が大集合！美味しい料理とお酒を頂きました！" },
      { type: "text", data: "前菜から" },
      { type: "image", data: "/images/ev_20250918_1.jpg" },
      { type: "text", data: "揚げ物" },
      { type: "image", data: "/images/ev_20250918_2.jpg" },
      { type: "text", data: "パスタなどなど、大変美味しゅうございました！また来期も頑張りましょう！" },
      { type: "image", data: "/images/ev_20250918_3.jpg" },
    ],
  },
];

// ─── 日付の新しい順にソートしてIDを自動採番 ─────────────────────────
// 新しいトピックスを追加するときは topicsRaw に追記するだけでOK
const topicsData = [...topicsRaw]
  .sort((a, b) => new Date(b.date) - new Date(a.date))
  .map((topic, index) => ({
    ...topic,
    id: index + 1, // 1始まりの連番IDを自動付与
  }));

export default topicsData;